/* eslint-disable @typescript-eslint/no-var-requires */

export const environment = {
  appVersion: '6.0.' + require('../../package.json').version.substring(0, 4),
  debug: false,
  production: true,
  port: process.env["NG_APP_PORT"] ?? "",
  deploymentType: 'onPremise',
  idpUri: process.env["NG_APP_IDENTITY_PROVIDER_URI"] ?? "",
  settingsUri: process.env["NG_APP_SETTINGS_URI"] ?? "",
  apiUri: process.env["NG_APP_API_URI"] ?? "",
  apiAiUri: process.env["NG_APP_API_AI_URI"] ?? "",
  tenant: process.env["NG_APP_TENANT"] ?? "",
  sentryDsn: process.env["NG_APP_SENTRY_DSN"] ?? "",
  sentryTraceSampleRate: process.env["NG_APP_SENTRY_TRACE_SAMPLE_RATE"] ?? "",
  sentryReplaySampleRate: process.env["NG_APP_SENTRY_REPLAY_SAMPLE_RATE"] ?? "",
  sentryReplayErrorsSampleRate: process.env["NG_APP_SENTRY_REPLAY_ERRORS_SAMPLE_RATE"] ?? "",
  sentryTracePropagationTargets: process.env["NG_APP_SENTRY_TRACE_PROPAGATION_TARGETS"] ?? "",
  sentryEnabled: process.env["NG_APP_SENTRY_ENABLED"] ?? "false",
  gojsLicenseKey: '73f942eab06228a800ca0d2b113f69ef1bb37f3b9ed11ba75e5641f3ea5f68433089ef2801d38bc282fe1afb1978c4ded4916c2a9e48036ce131d38945e085ffe13177b2435a4486a7512e91ccaa2fa2ee6877a792b377f08a799ee2e8a9c09e43eaecdc',
  providers: [
  ],
};
